<template>
  <vx-card class="w-full">
    <form>
      <div class="vx-row mb-4 mt-6">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="شماره همراه"
            v-model="mobileNo"
            disabled
          />
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="نام"
            v-model="firstname"
          />
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="نام خانوادگی"
            v-model="lastname"
          />
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <vs-input
            type="email"
            class="w-full"
            label-placeholder="کد ملی"
            v-model="nationalCode"
            v-validate="'required'"
            name="email"
          /><span class="text-danger text-sm" v-show="errors.has('email')"
            >ایمیل را وارد کنید</span
          >
        </div>
      </div>
      <div class="vx-row w-full mb-2 ml-0 px-0">
        <div class="vx-col w-full mx-0 px-0">
          <!-- <vs-input
          class="w-full"
          label-placeholder="تاریخ تولد"
          v-model="input23"
        /> -->
          <div class="mb-2" style="font-size: 9.8px; color: rgba(0, 0, 0, 0.4)">
            تاریخ تولد
          </div>
          <div class="">
            <date-picker
              inputClass="py-1 pl-3 br-5 w-full"
              v-model="birthDate"
              class="mt-3"
              v-validate="'required'"
              name="birthDate"
            ></date-picker>
            <span class="text-danger text-sm" v-show="errors.has('birthDate')"
              >تاریخ را وارد کنید</span
            >
          </div>
        </div>
      </div>
      <div class="vx-row mb-2 mt-4">
        <div class="vx-col w-full">
          <vs-button class="mb-2 float-right" @click.prevent="submit"
            >تائید</vs-button
          >
        </div>
      </div>
    </form>
  </vx-card>
</template>
<style lang="scss">
.birthdateclass {
  rull {
    font-size: 14px;
    margin: 17px;
  }
}
</style>
<script>
import jwt from "../../../http/requests/auth/jwt/index.js";

export default {
  data() {
    return {
      firstname: "",
      lastname: "",
      nationalCode: "",
      birthDate: "",
      mobileNo: "",
    };
  },

  methods: {
    getUserProfile() {
      let loading = this.$vs.loading();
      this.$http
        .get("api/services/app/UserProfiles/GetUserProfileByUserId")
        .then((response) => {
          try {
            this.firstname = response.data.result.firstname;
            this.lastname = response.data.result.lastname;
            this.birthDate = this.$moment(response.data.result.birthdate).format(
              "jYYYY/jM/jD"
            );
            this.nationalCode = response.data.result.nationalCode;
            this.mobileNo = response.data.result.mobile;
          } catch (err) {}
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },

    async submit() {
      await this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$vs.notify({
                  time: 5000,
                  color: "warning",
                  title: "خطا!",
                  text: "مقادیر خواسته شده را وارد کنید",
                });
          return;
        } else {
          let loading = this.$vs.loading();
          let payload = {
            firstname: this.firstname,
            lastname: this.lastname,
            nationalCode: this.nationalCode,
            birthdate: this.$moment(this.birthDate, "jYYYY/jMM/jDD").format(),
          };

          this.$http
            .post("/api/services/app/UserProfiles/CreateOrEdit", payload)
            .then((response) => {
              if (response.data.success == true) {
                this.$vs.notify({
                  time: 5000,
                  color: "success",
                  title: "موفق!",
                  text: "اطلاعات کاربری با موفقیت ذخیره شد",
                });
                this.$emit("success");
                this.$store.dispatch("auth/setProfileData");
              }
              this.$vs.loading.close();
            }) //end success
            .catch((error) => {
              this.$vs.loading.close();
            }); //end http
        }
      });
    },
  },
  mounted() {
    this.getUserProfile();
  },
};
</script>

        